<template>
  <div style='margin: 2em'>
    <div v-for='widget in widgets' :key='widget.id'>
      <div style='margin-top: 1em'>
        <component :is='widget.type' :widget='widget' />
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import moment from 'moment'
import NumberWidget from '../widgets/NumberWidget'
import DashboardGrid from '../DashboardGrid'
import DoughnutWidget from '../widgets/DoughnutWidget'
import LinechartWidget from '../widgets/LinechartWidget'
import BarWidget from '../widgets/BarWidget'
import TableWidget from '../widgets/TableWidget'
import GaugeWidget from '../widgets/GaugeWidget'
import GalleryWidget from '../widgets/GalleryWidget'
import { Callout } from '@coreui/vue'
import { dashboardMixins } from '@/shared/DashboardMixins'

export default {
  name: 'PrintDashboard',
  mixins: [dashboardMixins],
  components: {
    DashboardGrid,
    Callout,
    NumberWidget,
    DoughnutWidget,
    LinechartWidget,
    BarWidget,
    TableWidget,
    GaugeWidget,
    GalleryWidget,
  },
  data: function () {
    return {
      widgets: [],
      sections: [],
      section_id: null,
      currentTab: 0,
      currentAdPreview: '',
      currentTabModel: null,
    }
  },
  created () {
    if (this.$route.query.start_date) {
      this.setStartDate(moment(this.$route.query.start_date))
      this.setEndDate(moment(this.$route.query.end_date))
    }
    if (this.$route.query.compare_start_date && this.$route.query.compare_end_date) {
      this.setCompareStartDate(moment(this.$route.query.compare_start_date))
      this.setCompareEndDate(moment(this.$route.query.compare_end_date))
    }
    this.setCurrentClient({id: parseInt(this.$route.query.client), domain: this.$route.query.client_domain})
    this.$store.dispatch('getDashboard', this.$route.params.id)
    this.resetWidgetData()
    this.getWindowWidth()
    if (this.$route.query.tab) {
      this.currentTab = parseInt(this.$route.query.tab)
    }
    this.loadSections()
  },
  methods: {
    ...mapMutations([
      'setCurrentClient',
      'setStartDate',
      'setEndDate',
      'setCompareStartDate',
      'setCompareEndDate',
      'resetWidgetData'
    ]),
    loadSections (newSectionId = null) {
      this.$http.get('/dashboards/'+ this.$route.params.id)
        .then(function(response){
          this.sections = response.data.sections.map((section) => {
            return {
              id: section.id,
              name: section.name,
              order: section.order
            }
          })
          this.sections.sort((a, b) => a.order - b.order)
          var section = this.sections.find((section) => parseInt(section.id,10) === parseInt(newSectionId, 10))
          this.$eventBus.$emit('loadSections', this.sections)
          setTimeout(()=> {this.currentTab = this.sections.indexOf(section)}, 200) // give time to rerender
          if (this.window.width < 768) {
            this.currentTabModel = this.sections[this.currentTab]
          }
          this.loadWidgets(newSectionId)
        }.bind(this))
        .catch((e) => console.log(e))
    },

    loadWidgets (sectionId = null){
      var params = { params: {} }
      if (sectionId === null && this.sections.length > 0){
        sectionId = this.sections[this.currentTab].id
      }
      if (sectionId){
        params.params.section_id = sectionId
      , this.downloadPPTX}
      this.$eventBus.$emit('selectSection', sectionId)
      this.$http.get('/dashboards/'+ this.$route.params.id +'/widgets', params)
        .then(response => this.showWidgets(response))
        .catch((e) => console.log(e))
    },

    showWidgets (response) {
      this.widgets = []
      this.$nextTick(() => {
        response.data.data.forEach((widget) => {
          this.widgets.splice(1,0,{
            id: parseInt(widget.id, 10),
            title: widget.attributes.title,
            widget_titles: widget.attributes.widget_titles.map((title) => title.title),
            type: widget.attributes.widget_type + 'Widget',
            dashboard_id: this.$route.params.id,
            audits: widget.attributes.audits,
            x: widget.attributes.grid_position.x,
            y: widget.attributes.grid_position.y,
            w: widget.attributes.grid_position.w,
            h: widget.attributes.grid_position.h,
            shared: widget.attributes.shared,
            filters: widget.attributes.filters,
            options: widget.attributes.options,
            owner_id: widget.attributes.owner_id,
            locked: widget.attributes.locked,
            disableLegend: widget.attributes.disable_legend,
            disableDataComparison: widget.attributes.disable_data_comparison,
            sectionIds: widget.attributes.section_ids,
            stacked_barchart: widget.attributes.data.stacked_barchart,
            funnel_order: widget.attributes.data.reverse_funnel,
            as_pyramid: widget.attributes.data.as_pyramid,
            click_through_section: widget.attributes.data.click_through_section,
            click_through: widget.attributes.data.click_through,
            state_history: widget.attributes.data.state_history
          })
        })
        this.widgets.sort(function(a,b){return a.y - b.y;});
      })
    }
  },
  props: [
    'start_date',
    'end_date',
    'compare_start_date',
    'compare_end_date'
  ],

  computed: {
    ...mapGetters(['dashboardData']),
    dashboardLoaded: function () {
      if (this.dashboardData.length > 0 && this.dashboardData.length == this.dashboardData.filter( w =>  w.data.length > 0).length) {
        return true
      } else if(this.dashboardData.length === 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
@media print {
  .page-break-print { page-break-before: always; }
}
</style>
